import React from "react";

import { Button, ButtonGroup } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import mapMarker from "images/map-marker.svg";

import styles from "./style.module.css";

export default class AibleStep extends React.PureComponent {
  state = {
    isEdit: false
  };

  renderChildren() {
    const { children, confirm, childHolderClassName, isConfirmed } = this.props;

    return confirm ? (
      <div className={childHolderClassName ? childHolderClassName : styles.childHolder}>
        {children}
        {isConfirmed ? (
          <div className={styles.confirmHolder}>{"Confirmed"}</div>
        ) : (
          <Button type="primary" onClick={() => confirm()} className={styles.confirmButton}>
            {"Looks Good"}
          </Button>
        )}
      </div>
    ) : (
      children
    );
  }

  render() {
    const {
      bId,
      isHome,
      blueprintId,
      message,
      secondaryMessage,
      children,
      childStyle,
      isBreak,
      messageStyle,
      optionsHolder,
      botMessage,
      isEmpty,
      isBlueprint,
      isEditing,
      style,
      className,
      description,
      updateDescription,
      showIcon,
      icon,
      hide,
      noMargin,
      messageClassName,
      iconSrc
    } = this.props;

    const { isEdit, first, second } = this.state;

    const fMessage = first ? first : description ? description.message : message;
    const sMessage = second ? second : description ? description.secondaryMessage : secondaryMessage;

    const canEdit = !isEdit && bId && isEditing === true;

    return (
      <div
        className={className ? className : styles.messageHolder}
        style={hide ? { padding: "0px", ...style } : { ...style }}
      >
        <div className={styles.topHold} style={hide ? { display: "none" } : {}}>
          <div
            className={
              styles.hold +
              " " +
              (canEdit ? styles.editHover : "") +
              " " +
              (isHome ? styles.homeHold : "") +
              " " +
              messageClassName
            }
            style={noMargin ? { margin: "0px" } : undefined}
          >
            <div
              className={styles.wide + " " + (isHome ? styles.homeWide : "")}
              style={isEdit ? { background: "rgb(244, 245, 250)" } : {}}
            >
              {showIcon ? (
                <div className={styles.aible}>
                  {icon ? (
                    icon
                  ) : (
                    <div className={styles.aibleIcon}>
                      <img src={iconSrc ? iconSrc : mapMarker} />
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
              <div
                className={
                  styles.bMsg +
                  " " +
                  styles.aibleStepBox +
                  " " +
                  (isBreak === true ? styles.breakMessage : styles.message) +
                  " " +
                  (isHome ? styles.homeMessage : "")
                }
                onClick={canEdit ? () => this.setState({ isEdit: true }) : () => {}}
              >
                {icon ? icon : ""}
                {isEdit ? (
                  <div className={styles.edit}>
                    <div className={styles.eHeader}>{"Edit Description"}</div>
                    <textarea
                      className={styles.editDesc}
                      value={fMessage}
                      onChange={(event) => this.setState({ first: event.target.value })}
                    />
                    <div className={styles.eHeader}>{"Edit Sub Description"}</div>
                    <textarea
                      className={styles.editDesc}
                      value={sMessage}
                      onChange={(event) => this.setState({ second: event.target.value })}
                    />
                    <div className={styles.eButton}>
                      <ButtonGroup>
                        <Button
                          type="secondary"
                          onClick={() => this.setState({ isEdit: false, first: undefined, second: undefined })}
                        >
                          {"Cancel"}
                        </Button>
                        <Button
                          type="primary"
                          onClick={() => {
                            updateDescription(
                              {
                                message: fMessage,
                                secondaryMessage: sMessage
                              },
                              blueprintId
                            );

                            return this.setState({ isEdit: false, first: undefined, second: undefined });
                          }}
                        >
                          {"OK"}
                        </Button>
                      </ButtonGroup>
                    </div>
                  </div>
                ) : (
                  <div
                    className={isBreak === true ? styles.breakAHolder : styles.aHolder}
                    style={{
                      marginBottom: children === undefined ? "0px" : "",
                      width: children === undefined || isEmpty || isBreak ? "100%" : "50%"
                    }}
                  >
                    <div className={styles.msg} style={messageStyle ? messageStyle : {}}>
                      <div className={styles.primaryMessage}>{fMessage}</div>
                      {sMessage && <div className={styles.secondaryMessage}>{sMessage}</div>}
                    </div>
                  </div>
                )}
                {isBreak !== true && this.renderChildren()}
                {botMessage && <div className={styles.botMsg}>{botMessage}</div>}
              </div>
            </div>
            {canEdit && (
              <div className={styles.editIcon} onClick={() => this.setState({ isEdit: true })}>
                <FontAwesomeIcon icon={faEdit} />
              </div>
            )}
          </div>
        </div>
        {isBreak === true && children && (
          <div className={styles.bChildrenHolder} style={hide ? { padding: "0px", ...childStyle } : { ...childStyle }}>
            {this.renderChildren()}
          </div>
        )}
      </div>
    );
  }
}
